<template>
  <div class="briefs-tareas-dashboard">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :cliente="cliente"
          :incluirFinalizadas="Boolean(incluirFinalizadas)"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
          <b-card no-header>
            <b-tabs @input="setTabIndex" justified>
              <b-tab :title="briefsTareasUsuario.usuario" v-for="(briefsTareasUsuario, index) in briefsTareas" :key="briefsTareasUsuario.usuarioId">
                <b-table 
                  :key="`table-${briefsTareasUsuario.usuarioId}-${forceUpdateKey}`"
                    hover
                    responsive 
                    class="registro"
                    :busy="tableBusy"
                    :items="briefsTareasUsuario.tareas" 
                    :fields="fields">
                  <div slot="table-busy" class="text-center">
                    <b-spinner class="table-spinner" label="Spinning" />
                  </div>              
                  <template v-slot:cell(fechaEntrega)="data">
                    <template v-if="!editandoFechaEntrega || briefTareaId != data.item.id">
                      <div @dblclick="editarFechaEntrega({ usuarioId: briefsTareasUsuario.usuarioId, item: data.item })">
                        {{ data.item.fechaEntrega | fecha }}
                      </div>
                    </template>
                    <template v-if="editandoFechaEntrega && briefTareaId == data.item.id">
                      <app-fecha-entrega
                        :currentFecha="fechaEntrega"
                        @updated="fechaEntregaActualizada"
                        @close="cancelarActualizacionFechaEntrega">
                      </app-fecha-entrega>
                    </template>
                  </template>
                  <template v-slot:cell(prioridad)="data">
                    <template v-if="!editandoPrioridad || briefTareaId != data.item.id">
                      <b-badge 
                          @dblclick="editarPrioridad({ usuarioId: briefsTareasUsuario.usuarioId, item: data.item })"
                          :variant="getBadgePrioridad(data.item)">
                        {{ data.item.prioridad }}
                      </b-badge>
                    </template>
                    <template v-if="editandoPrioridad && briefTareaId == data.item.id">
                      <app-prioridad
                        :nombre="prioridadNombre"
                        :lista="prioridadesList"
                        @updated="prioridadActualizada"
                        @close="cancelarActualizacionPrioridad">
                      </app-prioridad>
                    </template>
                  </template>
                  <template v-slot:cell(briefTareaEstado)="data">
                    <template v-if="!editandoEstado || briefTareaId != data.item.id">
                      <b-badge 
                          @dblclick="editarEstado( { usuarioId: briefsTareasUsuario.usuarioId, item: data.item } )"
                          :style='"background-color: " + data.item.briefTareaEstadoColor + ";color: " + data.item.briefTareaEstadoFontColor + ";"'>
                        {{ data.item.briefTareaEstado }}
                      </b-badge>
                    </template>
                    <template v-if="editandoEstado && briefTareaId == data.item.id">
                      <app-estado
                        :nombre="briefTareaEstadoNombre"
                        :lista="estadosList"
                        @updated="briefTareaEstadoActualizado"
                        @close="cancelarActualizacionEstado">
                        <!-- @validate="validate" -->
                      </app-estado>
                    </template>
                  </template>
                  <template v-slot:cell(opciones)="data">
                    <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                      <template slot="button-content">
                        <i class="fa fa-ellipsis-v"></i>
                      </template>
                      <b-dropdown-item 
                          @click.stop="editarItem({ usuarioId: briefsTareasUsuario.usuarioId, item: data.item })">
                        <i class="fa fa-edit"></i>Editar Tarea</b-dropdown-item>
                      <!-- <b-dropdown-item 
                          @click.stop="eliminarItem(data.item.id)">
                        <i class="fa fa-remove"></i>Eliminar Tarea</b-dropdown-item> -->
                      <b-dropdown-item 
                          @click.stop="consultarBrief(data.item.briefId)">
                        <i class="fa fa-folder"></i>Consultar Brief</b-dropdown-item>
                    </b-dropdown>
                  </template>
                  <template v-slot:cell(detailShowing)="row">
                    <b-btn class="detailShowing" 
                        size="sm"
                        v-if="row.item.descripcion != ''" 
                        @click.stop="toggleRowDetails(row.item)">
                      {{ row.item._showDetails ? '-' : '+' }}
                    </b-btn>
                  </template>
                  <template v-slot:row-details="row">
                    <p>{{ row.item.descripcion }}</p>
                  </template>
                </b-table>
              </b-tab>
            </b-tabs>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <b-modal ref="tareaModal"
        title="Tarea"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-tarea
        :briefId="briefId"
        :briefTareaId="briefTareaId"
        @saved="tareaActualizada"
        @canceled="tareaActualizacionCancelada">
      </app-tarea>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Tarea from './ABM.vue'
import Filtro from './listFiltroDashboard.vue';
import Estado from '../shared/listSelect.vue';
import Prioridad from '../shared/listSelect.vue';
import FechaEntrega from '../shared/listDate.vue';
// import Dashboard from './tareas.vue';
// import DashboardGeneral from './tareas.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'briefsTareasDashboard/getField',
  mutationType: 'briefsTareasDashboard/updateField',
});

export default {
  name: 'BriefsTareasDashboardUsuarios',
  components: {
    // appDashboard: Dashboard,
    // appDashboardGeneral: DashboardGeneral,
    appTarea: Tarea,
    appFiltro: Filtro,
    appEstado: Estado,
    appPrioridad: Prioridad,
    appFechaEntrega: FechaEntrega,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal,
  ],
  data: () => {
    return {
      fields: [
        {
          key: 'detailShowing',
          label: '',
          class: 'text-center'
        },
        {
          key: 'briefId',
          label: 'Nro.Brief',
          sortable: true
        },
        {
          key: 'titulo',
        },
        // {
        //   key: 'usuario',
        //   label: 'Responsable',
        //   class: 'text-center'
        // },
        // {
        //   key: 'usuarioIniciales',
        //   label: 'Responsable',
        //   class: 'text-center'
        // },
        {
          key: 'briefTareaEstado',
          label: 'Estado',
          sortable: true
        },

        {
          key: 'fechaEntrega',
          label: 'Entrega',
          sortable: true
        },
        {
          key: 'prioridad',
          sortable: true
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],
      tableBusy: false,
      
      labelCols: 2,
      briefId: 0,
      briefTareaUsuarioId: 0,
      briefTareaId: 0,
      prioridadActualId: 0,
      prioridadActualNombre: null,
      briefTareaEstadoActualId: 0,
      briefTareaEstadoActualNombre: null,
      usuarioActualId: 0,
      usuarioActualNombre: null,

      editandoEstado: false,
      briefTareaEstadoNombre: null,
      estados: [],
      estadosList: [],

      editandoPrioridad: false,
      prioridadNombre: null,
      prioridades: [],
      prioridadesList: [],

      editandoFechaEntrega: false,
      fechaEntrega: moment(new Date()).format('YYYY-MM-DD'),

      forceUpdateKey: 0,
      // showDashboard: true,
      // showDashboardGeneral: false,

      // opcionDashboardPropio: false
    }
  },
  computed: {
    ...mapFields([
      'briefsTareas',
      'briefsTareasTerceros',
      'cliente',
      'tareasTerceros',
      'usuario',
      'incluirFinalizadas'
    ]),
  },
  created() {
    // this.opcionDashboardPropio = Boolean(this.$store.getters['user/tieneAccesoModulo']('DisenioDashboardUsuario'));
    
    this.getDatosAdicionales();
    this.getItems();
  },  
  methods: {
    getBadgePrioridad(item) {
      switch (item.prioridadId) {
        case 1: //Urgente
          return 'danger';
        case 2: //Alta
          return 'danger';
        case 3: //Normal
          return 'warning';
        case 4: //Baja
          return 'success';
        default:
          return '';
      }
    },
    filtrar(filtro) {
      this.cliente = filtro.cliente;
      this.incluirFinalizadas = Boolean(filtro.incluirFinalizadas);
      // this.tareasTerceros = filtro.tareasTerceros;
      // this.usuario = filtro.usuario;
      
      this.getItems();
    },
    setTabIndex() {
      
    },
    getDatosAdicionales() {
      this.$store.dispatch('briefsTareasEstados/getList')
        .then(() => {
          this.estados = this.$store.getters['briefsTareasEstados/list'];
          this.estadosList = this.$store.getters['briefsTareasEstados/selectList'];
        })

      this.$store.dispatch('prioridades/getList')
        .then(() => {
          this.prioridades = this.$store.getters['prioridades/list'];
          this.prioridadesList = this.$store.getters['prioridades/selectList'];
        })
    },
    getItems() {
      this.showSpinner();
      this.$store.dispatch('briefsTareasDashboard/getBriefsTareas')
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    // agregarTarea (briefId) {
    //   this.briefId = briefId;
    //   this.briefTareaId = 0;
    //   this.$refs.tareaModal.show();
    // },
    editarItem (params) {
      this.briefTareaUsuarioId = params.usuarioId;
      this.briefId = params.item.briefId;
      this.briefTareaId = params.item.id;
      this.$refs.tareaModal.show();
    },
    tareaActualizada(briefTarea) {
      this.$refs.tareaModal.hide();
      
      if (briefTarea) {
        let params = {
          usuarioId: this.briefTareaUsuarioId,
          briefTarea
        }

        this.$store.dispatch('briefsTareasDashboard/setBriefTarea', params)
          // .then(() => this.$refs.dashboard.refresh())
          .catch(error => this.showErrorMsj(error))
      }
    },
    tareaActualizacionCancelada() {
      this.$refs.tareaModal.hide();
    },
    // eliminarItem(briefTareaId) {
    //   this.showModalConfirm('¿Desea eliminar la tarea seleccionada?', 
    //     this.delete.bind(this, briefTareaId), 'Si', 
    //     null, 'No');
    // },
    // delete(briefTareaId) {
    //   this.showSpinner();
    //   this.$store.dispatch('briefsTareas/delete', briefTareaId)
    //     .then(() => this.showModalMsj('La tarea se eliminó con éxito', null, null, 'light'))
    //     .catch(error => this.showErrorMsj(error))
    //     .finally(() => this.hideSpinner());
    // },
    consultarBrief (briefId) {
      this.$router.push({ name: 'BriefData', 
                          params: { id: briefId }});
    },
    editarEstado(params) {
      this.editandoEstado = true;
      this.briefTareaUsuarioId = params.usuarioId;
      this.briefTareaId = params.item.id;
      this.briefTareaEstadoNombre = params.item.briefTareaEstado;
    },
    briefTareaEstadoActualizado(briefTareaEstadoNombre) {
      let briefTareaEstado;
      if (briefTareaEstadoNombre) {
        briefTareaEstado = this.getSelected(this.estados, briefTareaEstadoNombre);
      }

      let params = {
        usuarioId: this.briefTareaUsuarioId,
        briefTareaId: this.briefTareaId,
        briefTareaEstadoId: briefTareaEstado ? briefTareaEstado.id : null,
        briefTareaEstado
      };

      this.showSpinner();
      this.$store.dispatch('briefsTareasDashboard/updateEstado', params)
        .then(() => this.editandoEstado = false)
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    cancelarActualizacionEstado() {
      this.editandoEstado = false;
    },
    editarPrioridad(params) {
      this.editandoPrioridad = true;
      this.briefTareaUsuarioId = params.usuarioId;
      this.briefTareaId = params.item.id;
      this.prioridadNombre = params.item.prioridad;
    },
    prioridadActualizada(prioridadNombre) {
      let prioridad;
      if (prioridadNombre) {
        prioridad = this.getSelected(this.prioridades, prioridadNombre);
      }

      let params = {
        usuarioId: this.briefTareaUsuarioId,
        briefTareaId: this.briefTareaId,
        prioridadId: prioridad ? prioridad.id : null,
        prioridad
      };

      this.showSpinner();
      this.$store.dispatch('briefsTareasDashboard/updatePrioridad', params)
        .then(() => this.editandoPrioridad = false)
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    cancelarActualizacionPrioridad() {
      this.editandoPrioridad = false;
    },
    editarFechaEntrega(params) {
      this.editandoFechaEntrega = true;
      this.briefTareaUsuarioId = params.usuarioId;
      this.briefTareaId = params.item.id;
      this.fechaEntrega = params.item.fechaEntrega;
    },
    fechaEntregaActualizada(fechaEntrega) {
      let params = {
        usuarioId: this.briefTareaUsuarioId,
        briefTareaId: this.briefTareaId,
        fechaEntrega
      };

      this.showSpinner();
      this.$store.dispatch('briefsTareasDashboard/updateFechaEntrega', params)
        .then(() => this.editandoFechaEntrega = false)
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    cancelarActualizacionFechaEntrega() {
      this.editandoFechaEntrega = false;
    },
    toggleRowDetails(item) {
      this.$set(item, '_showDetails', !item._showDetails);

      this.forceUpdateKey++;
    }
  },
  watch: {
  }    
}
</script>

<style>
  .briefs-tareas-dashboard .dashboard .card-body {
    padding-top: 0;
    padding-bottom: 0;
  }
  .briefs-tareas-dashboard .dashboard.show .card-body {
    max-height: 500px;
    min-height: 350px;
    overflow-y: auto;
    padding: 1.25rem;
  }

  .briefs-tareas-dashboard .registro table {
    margin-bottom: 20px;
  }
  .briefs-tareas-dashboard .registro table th {
    border-top: none;
  }
  .briefs-tareas-dashboard .registro table td {
    padding-top: 10px;
    padding-bottom: 5px;
  }
  .briefs-tareas-dashboard .registro table td[aria-colindex="1"] {
    width: 15px;
  }
  .briefs-tareas-dashboard .registro table td[aria-colindex="2"] {
    width: 10%;
  }
  .briefs-tareas-dashboard .registro table td[aria-colindex="3"] {
    width: calc(45% - 45px);
  }
  .briefs-tareas-dashboard .registro table td[aria-colindex="4"] {
    width: 15%;
  }
  .briefs-tareas-dashboard .registro table td[aria-colindex="5"] {
    width: 15%;
  }
  .briefs-tareas-dashboard .registro table td[aria-colindex="6"] {
    width: 15%;
  }
  .briefs-tareas-dashboard .registro table td[aria-colindex="7"] {
    width: 30px;
  }

  .briefs-tareas-dashboard .registro span.badge {
    /* font-size: 1em;
    font-weight: normal; */
    width: 95%;
    padding: 5px;
    font-weight: 400;
  }

  .briefs-tareas-dashboard .registro .btn.detailShowing {
    position: relative;
    top: -5px;
  }
  .briefs-tareas-dashboard .registro .b-table-details td {
    padding-top: 0;
    padding-bottom: 15px;
    padding-left: 30px;
  }
  .briefs-tareas-dashboard .registro .b-table-details td p {
    margin-bottom: 0;
    white-space: pre-line;
  }
</style>
